import React from 'react';
import { Box, Container, Typography, Button, Toolbar } from '@mui/material';

const HeroSection = () => {
  return (
    <Box sx={{ position: 'relative', width: '100%' }}>
      <Toolbar sx={{ height: '64px' }} />

      <Box
        sx={{
          position: 'relative',
          width: '100%',
          minHeight: { xs: '90vh', md: '94vh' },
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          backgroundColor: '#080808',
          overflow: 'hidden',
        }}
      >
        {/* Background image */}
        <Box
          component="img"
          src="./hero.jpg"
          alt=""
          aria-hidden="true"
          sx={{
            position: 'absolute',
            inset: 0,
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            objectPosition: 'center 55%',
            filter: 'grayscale(100%) brightness(0.58)',
            userSelect: 'none',
            pointerEvents: 'none',
          }}
        />

        {/* Layered gradient: dark top + teal hint bottom-left */}
        <Box
          sx={{
            position: 'absolute',
            inset: 0,
            background: [
              'radial-gradient(ellipse 80% 60% at 10% 80%, rgba(0,77,64,0.22) 0%, transparent 70%)',
              'linear-gradient(180deg, rgba(0,0,0,0.6) 0%, rgba(0,0,0,0.18) 45%, rgba(0,0,0,0.72) 100%)',
            ].join(', '),
            pointerEvents: 'none',
          }}
        />

        {/* Content */}
        <Container
          maxWidth="lg"
          sx={{
            position: 'relative',
            zIndex: 2,
            textAlign: 'center',
            py: { xs: 10, md: 14 },
          }}
        >
          {/* Pill badge */}
          <Box
            sx={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: 1,
              border: '1px solid rgba(0,77,64,0.6)',
              backgroundColor: 'rgba(0,77,64,0.12)',
              borderRadius: '100px',
              px: 2,
              py: 0.6,
              mb: 4,
            }}
          >
            <Box
              sx={{
                width: 6,
                height: 6,
                borderRadius: '50%',
                backgroundColor: '#00BFA5',
                boxShadow: '0 0 6px #00BFA5',
              }}
            />
            <Typography
              sx={{
                fontFamily: 'Outfit',
                fontWeight: 500,
                fontSize: '0.78rem',
                color: 'rgba(255,255,255,0.75)',
                letterSpacing: '0.1em',
                textTransform: 'uppercase',
              }}
            >
              IoT Temperature Monitoring
            </Typography>
          </Box>

          <Typography
            component="h1"
            sx={{
              fontFamily: 'Outfit',
              fontWeight: 800,
              fontSize: { xs: '3rem', sm: '4rem', md: '5.5rem' },
              color: '#ffffff',
              lineHeight: 1.0,
              letterSpacing: '-0.035em',
              mb: 3.5,
            }}
          >
            Remote
            <Box
              component="span"
              sx={{
                display: 'block',
                background: 'linear-gradient(90deg, #ffffff 0%, rgba(255,255,255,0.55) 100%)',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
                backgroundClip: 'text',
              }}
            >
              Temperature
            </Box>
            Monitoring
          </Typography>

          <Typography
            component="p"
            sx={{
              fontFamily: 'Outfit',
              fontWeight: 300,
              fontSize: { xs: '1.1rem', md: '1.35rem' },
              color: 'rgba(255,255,255,0.6)',
              letterSpacing: '0.01em',
              mb: 7,
              maxWidth: 520,
              mx: 'auto',
            }}
          >
            Data Insights &amp; Compliance, Delivered
          </Typography>

          {/* CTA buttons */}
          <Box sx={{ display: 'flex', gap: 2, justifyContent: 'center', flexWrap: 'wrap' }}>
            <Button
              href="#features"
              disableElevation
              sx={{
                fontFamily: 'Outfit',
                fontWeight: 600,
                fontSize: '0.95rem',
                textTransform: 'none',
                backgroundColor: '#004D40',
                color: '#ffffff',
                px: 4,
                py: 1.5,
                borderRadius: '7px',
                '&:hover': { backgroundColor: '#00695C' },
                transition: 'background-color 0.2s',
              }}
            >
              Learn More
            </Button>
            <Button
              href="https://app.sigmatiqa.com"
              disableElevation
              sx={{
                fontFamily: 'Outfit',
                fontWeight: 500,
                fontSize: '0.95rem',
                textTransform: 'none',
                backgroundColor: 'rgba(255,255,255,0.07)',
                color: '#ffffff',
                border: '1px solid rgba(255,255,255,0.18)',
                px: 4,
                py: 1.5,
                borderRadius: '7px',
                backdropFilter: 'blur(8px)',
                '&:hover': { backgroundColor: 'rgba(255,255,255,0.13)' },
                transition: 'background-color 0.2s',
              }}
            >
              Log in to Dashboard
            </Button>
          </Box>
        </Container>

        {/* Bottom fade to white */}
        <Box
          sx={{
            position: 'absolute',
            bottom: 0,
            left: 0,
            right: 0,
            height: '2px',
            background: 'linear-gradient(to bottom, transparent, #ffffff)',
            pointerEvents: 'none',
            zIndex: 3,
          }}
        />
      </Box>
    </Box>
  );
};

export default HeroSection;